export interface TileCopy {
    modalTitle: string;
    bullets: string[];
    modalButton: string;
    tileLabel: (ctx: { hasPolicies: boolean }) => string;
}

export const PRODUCT_TILE_COPY: Record<string, TileCopy> = {
    Default: {
        modalTitle: "Our Allianz products",
        bullets: [
            "View your Allianz Online Car or Home Insurance quotes",
            "Get a new Allianz Online Car or Home Insurance quote",
            "Get a new LV= Travel or LV= Pet Insurance quote",
        ],
        modalButton: "More about Allianz products",
        tileLabel: () => "Our products & quotes",
    },

    Britannia: {
        modalTitle: "Our Britannia products",
        bullets: [
            "View your Britannia Car Insurance quote(s)",
            "Get a new Britannia Car Insurance quote",
        ],
        modalButton: "More about Britannia products",
        tileLabel: ({ hasPolicies }) =>
            hasPolicies ? "View/edit my quotes" : "Get a quote",
    },
};
